import AgoraRTC from 'agora-rtc-sdk-ng'
import dayjs from 'dayjs'
import MD5 from 'md5'
import { useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast'

import { getDeviceInfo } from '@/api/center'
import { deviceInfoStore, useSetRecoilState } from '@/store'
AgoraRTC.setLogLevel(3)
const { deviceShowState } = deviceInfoStore

/**
 * 本地取设备信息，与登录返回的服务器保存的设备信息比较
 * 一致则设备无需检测，不一致设备检测，检测完成后保存至服务器，本地localStorage.devices修改成最新设备信息
 */
export const checkDevice = async () => {
  const timestamp = (Date.now() / 1000).toFixed(0)
  const res = await getDeviceInfo({
    userId: localStorage.userid,
    userType: 2,
    sign: MD5(`userId=${localStorage.userid}&userType=2&timestamp=${timestamp}&key=${import.meta.env.VITE_APP_userSecretKey}`),
    timestamp
  })
  const { data, status } = res
  if (status !== 0) {
    // 未登录
    return true
  }

  let devices = {
    cameraId: '',
    microphoneId: '',
    speakerId: ''
  }
  if (data.length) {
    devices = data[0]
  }
  let localDevices = null
  try {
    localDevices = await AgoraRTC.getDevices()
  } catch {}
  if (!localDevices) {
    toast.error('请允许浏览器及网页访问摄像头和麦克风设备')
    return false
  }
  const deviceTest = localStorage.deviceTest
  console.log('deviceTest', deviceTest)
  console.log('服务端设备：', devices)
  console.log('本地设备：', localDevices)
  let state = false
  if (deviceTest === 'true' && devices.cameraId && devices.microphoneId && devices.speakerId) {
    const videoinput: string[] = []
    const audioinput: string[] = []
    const audiooutput: string[] = []
    localDevices.forEach((device: { kind: string; deviceId: string }) => {
      if (device.kind === 'videoinput') {
        videoinput.push(device.deviceId)
      }
      if (device.kind === 'audioinput') {
        audioinput.push(device.deviceId)
      }
      if (device.kind === 'audiooutput') {
        audiooutput.push(device.deviceId)
      }
    })
    const cameraId = devices.cameraId.split(',')
    const microphoneId = devices.microphoneId.split(',')
    const speakerId = devices.speakerId.split(',')

    const cameraIdPare = videoinput.sort().toString() === cameraId.sort().toString()
    const microphoneIdPare = audioinput.sort().toString() === microphoneId.sort().toString()
    const speakerIdPare = audiooutput.sort().toString() === speakerId.sort().toString()
    if (cameraIdPare && microphoneIdPare && speakerIdPare) {
      state = true
    }
  }

  return state
}

export default function Index() {
  const [msg, setMsg] = useState<string>('')
  const setDeviceShow = useSetRecoilState(deviceShowState)

  const check = async () => {
    // 一天提示一次
    const today = dayjs().format('YYYY-MM-DD')
    const lastCheckDate = localStorage.getItem('lastCheckDate')
    if (lastCheckDate === today) {
      console.log('今天已经提示过设备检测了')
      return
    }
    if (localStorage.userid) {
      const state = await checkDevice()
      if (!state) {
        console.log('设备对比不一致，设备检测')
        localStorage.deviceTest = 'false'
        localStorage.setItem('lastCheckDate', today)
        setDeviceShow(true)
      } else {
        console.log('设备对比成功，无需检测')
      }
    }
  }

  useEffect(() => {
    // 检测到镜头设备发生改变
    AgoraRTC.onCameraChanged = () => {
      setMsg('检测到镜头设备发生改变')
      check()
    }
    // 检测到麦克风设备发生改变
    AgoraRTC.onMicrophoneChanged = () => {
      setMsg('检测到麦克风设备发生改变')
      check()
    }
    // 检测到音频播放设备发生改变
    AgoraRTC.onPlaybackDeviceChanged = () => {
      setMsg('检测到音频播放设备发生改变')
      check()
    }
    check()
  }, [])

  return [msg] as const
}
